<!-- TODO same: src/components/items/NoDataSelectVListItem.vue -->
<script setup lang="ts"></script>

<template>
  <div :class="$style.noticesEmptyText" data-testid="noticesEmptyText">
    <p>There are no such notifications</p>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
.noticesEmptyText {
  text-align: center;
  font-size: 1.125rem;
  padding: 0 0 20px 0;
}
</style>
